// extracted by mini-css-extract-plugin
module.exports = {"toggleBtn":"ImportantIndicatorToggle_toggleBtn__3mfUE","indicator":"ImportantIndicatorToggle_indicator__3POOl","activeIndicator":"ImportantIndicatorToggle_activeIndicator__3-c1M"};